
import { PrimeVueLocaleOptions } from "primevue/config";
import Dropdown from "primevue/dropdown";
import { Component, Prop, Vue } from "vue-property-decorator";

import config from "@/config";

@Component({ components: { Dropdown } })
export default class LanguageSelect extends Vue {
  @Prop({ default: false, type: Boolean }) private readonly withIcon!: boolean;

  getLabel(code: string) {
    return this.$t(`languages.long.${code}`);
  }

  get availableLocales(): string[] {
    return config.i18n.availableLocales;
  }

  get currentLanguage(): string {
    if (!this.availableLocales.includes(this.$i18n.locale)) {
      this.$i18n.locale = this.$i18n.fallbackLocale.toString();
    }
    return this.$i18n.locale;
  }

  set currentLanguage(languageCode: string) {
    this.$i18n.locale = languageCode;
    const shortLocale = this.$i18n.locale.split("-")[0];
    if ((window as any).mtcaptchaConfig) {
      (window as any).mtcaptchaConfig.lang = shortLocale;
    }

    const html = document.documentElement; // returns the html tag
    html.setAttribute("lang", shortLocale);

    window.localStorage.setItem("phellow:language", this.$i18n.locale);
    this.$primevue.config.locale = this.$i18n.messages[this.$i18n.locale]
      .global as unknown as PrimeVueLocaleOptions;

    if (this.$route.name == "legal" || this.$route.name == "privacy") {
      this.$router.replace({
        name: this.$route.name!,
        query: { language: shortLocale },
      });
    }
  }
}
